import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { em } from 'polished';
import { map } from 'lodash';
import styled from 'styled-components';
import {
  ClickAwayListener,
  Divider,
  Drawer,
  Hidden,
  List,
  ListItem,
} from '@material-ui/core';
import { appTheme } from '../../../theme';
import { DRAWER_WIDTH } from '../constants';

const NavigationList = styled(List)`
  padding-top: 0;
`;

const MenuItem = styled(ListItem)`
  padding: 0;
`;

const MenuLink = styled(NavLink)`
  color: inherit;
  display: block;
  padding: ${appTheme.spacing.default} ${em('10px')};
  text-decoration: none;
  width: 100%;

  :hover,
  :focus {
    background-color: ${appTheme.system.passiveHover};
  }

  &.active {
    background-color: ${appTheme.system.active};
    color: ${appTheme.system.white};
    font-weight: 600;
  }
`;

const Sidebar = styled(props => (
  <Drawer {...props} classes={{ paper: 'paper' }} />
))`
  & .paper {
    background-color: ${appTheme.system.passive};
    height: 100%;
    margin-top: ${appTheme.sizing.headerHeight};
    overflow: auto;
    padding-bottom: ${appTheme.sizing.headerHeight};
    width: ${em(DRAWER_WIDTH)};
  }
`;

function NavigationDrawer({ handleCloseDrawer, menuItems }) {
  return (
    <NavigationList onClick={handleCloseDrawer}>
      {map(menuItems, item => (
        <React.Fragment key={item.route}>
          <Divider />
          <MenuItem>
            <MenuLink to={item.route}>{item.name}</MenuLink>
          </MenuItem>
        </React.Fragment>
      ))}
    </NavigationList>
  );
}

NavigationDrawer.propTypes = {
  menuItems: PropTypes.array.isRequired,
  handleCloseDrawer: PropTypes.func,
};

NavigationDrawer.defaultProps = {
  handleCloseDrawer: () => {},
};

function NavigationSidebar({ isOpen, handleCloseDrawer, menuItems }) {
  return (
    <div>
      <Hidden mdUp>
        <Sidebar open={isOpen} variant="temporary">
          <ClickAwayListener onClickAway={handleCloseDrawer}>
            <NavigationDrawer
              handleCloseDrawer={handleCloseDrawer}
              menuItems={menuItems}
            />
          </ClickAwayListener>
        </Sidebar>
      </Hidden>
      <Hidden smDown>
        <Sidebar variant="permanent">
          <NavigationDrawer menuItems={menuItems} />
        </Sidebar>
      </Hidden>
    </div>
  );
}

NavigationSidebar.propTypes = {
  handleCloseDrawer: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  menuItems: PropTypes.array.isRequired,
};

export default NavigationSidebar;



// WEBPACK FOOTER //
// ./src/modules/App/components/NavigationSidebar.js